import { render, staticRenderFns } from "./DropZone.vue?vue&type=template&id=62883bec&scoped=true"
import script from "./DropZone.vue?vue&type=script&lang=ts"
export * from "./DropZone.vue?vue&type=script&lang=ts"
import style0 from "./DropZone.vue?vue&type=style&index=0&id=62883bec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62883bec",
  null
  
)

export default component.exports